"use client";
import { useRouter } from "next/router";
import Header from "../../components/common/Header";
import CommonBanner2 from "../../components/common/CommonBanner2";
import AsSeenSection2 from "../../components/common/AsSeenSection2";
import TestimonialsSection from "../../components/common/TestimonialsSection";
import Clients from "../../components/clients";
import ServicesList from "../../components/services-list";
import FaqSection from "../../components/common/FaqSection";
import Footer from "../../components/footer";
import { useTranslation } from "next-i18next";

const Services = ({ services }) => {
  const { t } = useTranslation("services");
  const router = useRouter();
  const lang = router.locale || "en";

  const faqs = [0, 1, 2, 3].map((i) => ({
    question: t(`services.faqs.${i}.question`),
    answer: t(`services.faqs.${i}.answer`),
  }));

  return (
    <>
      <Header />
      <main className="w-full box-border bg-background-color-primary overflow-hidden">
        {/* <CommonBanner2 name={t("services.banner.title")} /> */}
        <CommonBanner2
          name={t("services.banner.title")}
          breadcrumbProps={{
            labelMap: {
              home: lang === "ar" ? "الرئيسية" : "Home",
              services: lang === "ar" ? "خدماتنا" : "Services",
            },
            separator: lang === "ar" ? "‹" : ">",
          }}
        />

        <ServicesList services={services} loading={false} />
        <AsSeenSection2 />
        <TestimonialsSection />
        <Clients />
        <FaqSection faqs={faqs} />
      </main>
      <Footer />
    </>
  );
};

export default Services;
